export default "__VITE_ASSET__BtOJJ4Qk__"